module.exports = __webpack_public_path__ + "static/img/patho-demodex-item-D3jqP4AS.8f8290ae.png";